module.exports = __webpack_public_path__ + "static/media/grass_fed_beef_1080.f142bb49.mp4";